import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

import { SignalElement } from "ui-common/di";

import { styles } from "./event-badge.css";

export type EventBadgeVariant = "scheduled" | "lobby" | "live" | "ended";

@customElement("event-badge")
export class EventBadge extends SignalElement {
  static override styles = [styles];

  @property({ type: String })
  variant: EventBadgeVariant = "scheduled";

  @property({ type: String })
  label = "";

  /**
   * When true, hides the dot indicator (useful when using slot for custom icon).
   */
  @property({ type: Boolean, attribute: "hide-dot" })
  hideDot = false;

  override render() {
    const badgeClasses = {
      "event-badge": true,
      [this.variant]: true,
    };

    return html`
      <div class=${classMap(badgeClasses)}>
        <slot name="icon">${this.hideDot ? nothing : html`<div class="dot"></div>`}</slot>
        <span>${this.label}</span>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "event-badge": EventBadge;
  }
}
